import { render, staticRenderFns } from "./searchAddition.vue?vue&type=template&id=67a01402&scoped=true"
import script from "./searchAddition.vue?vue&type=script&lang=js"
export * from "./searchAddition.vue?vue&type=script&lang=js"
import style0 from "./searchAddition.vue?vue&type=style&index=0&id=67a01402&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a01402",
  null
  
)

export default component.exports